<template>
  <BasePopUp v-if="showModal" @detailsClosed="closeConfirmRequested">
    <div v-if="user && !rejectModal" class="modal-body-container p-3">
      <!-- Title -->
      <h5 class="my-3 font-weight-bold">{{$t("userInfo")}}</h5>
      <p><span class="font-weight-bold">{{ $t("orderDetail.name") }}: </span>{{ user.name }}</p>
      <p><span class="font-weight-bold">{{ $t("orderDetail.email") }}: </span>{{ user.email }}</p>
      <p><span class="font-weight-bold">{{ $t("orderDetail.company") }}: </span>{{ user.company }}</p>
      <p><span class="font-weight-bold">{{ $t("orderDetail.vat") }}: </span>{{ user.vat }}</p>
      <p><span class="font-weight-bold">{{ $t("orderDetail.brand") }}: </span>{{ user.brand }}</p>
      <p v-if="user.phoneNumber"><span class="font-weight-bold">{{ $t("orderDetail.phoneNumber") }}: </span>{{ user.phoneNumber }}</p>
      <hr class="w-100 mb-4"/>
      <div class="d-flex flex-wrap justify-content-between">
        <div v-if="user.addresses[0]">
          <h5 class="mb-4 text-left font-weight-bold">{{ $t("address.invoice") }}</h5>
          <p v-if="user.addresses[0].name" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.name") }}: </span>{{user.addresses[0].name}}</p>
          <p v-if="user.addresses[0].email" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.email") }}: </span>{{user.addresses[0].email}}</p>
          <p v-if="user.addresses[0].phone" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.phone") }}: </span>{{user.addresses[0].phone}}</p>
          <p v-if="user.addresses[0].companyName" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.company") }}: </span>{{user.addresses[0].companyName}}</p>
          <p v-if="user.addresses[0].vat" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.nif") }}: </span>{{user.addresses[0].vat}}</p>
          <p v-if="user.addresses[0].country" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.country") }}: </span>{{user.addresses[0].country}}</p>
          <p v-if="user.addresses[0].street" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.address") }}: </span>{{user.addresses[0].street}}</p>
          <p v-if="user.addresses[0].zipCode" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.zip") }}: </span>{{user.addresses[0].zipCode}}</p>
          <p v-if="user.addresses[0].state" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.location") }}: </span>{{user.addresses[0].state}}</p>
          <p v-if="user.addresses[0].city" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.city") }}: </span>{{user.addresses[0].city}}</p>
        </div>
        <div v-if="user.addresses[1]">
          <h5 class="mb-4 text-left font-weight-bold">{{ $t("address.shipping") }}</h5>
          <p v-if="user.addresses[1].name" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.name") }}: </span>{{user.addresses[1].name}}</p>
          <p v-if="user.addresses[1].email" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.email") }}: </span>{{user.addresses[1].email}}</p>
          <p v-if="user.addresses[1].phone" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.phone") }}: </span>{{user.addresses[1].phone}}</p>
          <p v-if="user.addresses[1].companyName" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.company") }}: </span>{{user.addresses[1].companyName}}</p>
          <p v-if="user.addresses[1].vat" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.nif") }}: </span>{{user.addresses[1].vat}}</p>
          <p v-if="user.addresses[1].country" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.country") }}: </span>{{user.addresses[1].country}}</p>
          <p v-if="user.addresses[1].street" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.address") }}: </span>{{user.addresses[1].street}}</p>
          <p v-if="user.addresses[1].zipCode" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.zip") }}: </span>{{user.addresses[1].zipCode}}</p>
          <p v-if="user.addresses[1].state" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.location") }}: </span>{{user.addresses[1].state}}</p>
          <p v-if="user.addresses[1].city" class="mb-2 text-left"><span class="font-weight-bold">{{ $t("address.city") }}: </span>{{user.addresses[1].city}}</p>
        </div>
      </div>
      <!-- Button -->
      <div class="d-flex justify-content-center py-3">
        <CButton type="button" class="btn btn-primary m-auto" @click="closeConfirmRequested">{{ $t("close") }}</CButton>
      </div>
    </div>
    <!-- Reject PopUp -->
    <div v-if="rejectModal == true" class="modal-body-container p-3">
      <!-- Title -->
      <h4 class="text-center py-4">{{ $t("rejectUser") }}</h4>
      <div class="d-flex flex-column px-3">
        <form class="d-flex flex-column">
            <div role="group" class="form-group flex-grow-1">
            <p class="mb-2 text-left">{{$t('rejectTxt')}}</p>
              <CTextarea vertical v-model="description" rows="3"/>
            </div>
            <!-- Action button + submitting --> 
            <div class="d-flex justify-content-center py-3">
              <CSpinner v-if="submitting" variant="success" small></CSpinner>
              <CButton v-if="!submitting" type="button" class="btn btn-primary m-auto" @click="submitClicked">{{ $t('confirm') }}</CButton>
              <CButton v-if="!submitting" type="button" class="btn btn-primary m-auto" @click="closeConfirmRequested">{{ $t("close") }}</CButton>
            </div>
        </form>
      </div>           
    </div>
  </BasePopUp>
</template>

<script>
import BasePopUp from "./BasePopUp.vue";
import { mapState, mapActions  } from 'vuex'
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'

export default {
  extends: BasePopUp,
  components: { BasePopUp, SingleOptionDropdown },
  data() {
    return {
      description: null
    }
  },
  props: {
    user: Object,
    rejectModal: Boolean
  },
  computed:
  {
    ...mapState('users', ['deleteUserOutput']),
    submitting: function()
    {
      return this.deleteUserOutput === null;
    }
  },
  methods: {
    ...mapActions('users', ['deleteUser']),

    closeConfirmRequested() {
      this.$emit("closeConfirmRequested");
    },
    submitClicked()
    {
      const description = this.description;
      const id = this.user.id;
      this.deleteUser({id, description});
    },
  },
  watch: {
    deleteUserOutput(val) {
      if(val != null)
      {
        if(val)
        {
          this.closeConfirmRequested();
        }
      }
    }
  },
};
</script>

<style scoped>
.modal-body-container {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  border-radius: 10px;
  min-height: 200px;
  min-width: 620px;
}

label {
  margin-bottom: 0;
  margin-top: 1rem;
}
</style>